// Navigation
const NavigationBar = () => import('@/components/NavigationBar')

// Menu Views
const MenuView = () => import('@/views/seller/MenuView')
const MenuItemView = () => import('@/views/seller/menu/MenuItemView.vue')

// Payouts Views
const PayoutsView = () => import('@/views/seller/PayoutsView')
const PayoutsAddDetailsView = () =>
  import('@/views/seller/PayoutsAddDetailsView')

// Orders Views
const UpcomingOrdersView = () => import('@/views/seller/UpcomingOrdersView')

// Schedule Views
const ScheduleView = () => import('@/views/seller/ScheduleView')

const sellerRoutes = [
  {
    path: '/seller/menu',
    name: 'MenuView',
    components: {
      default: MenuView,
      navigation: NavigationBar
    },
    meta: {
      requiresAuth: true,
      transitionName: 'slide-up',
      sitemap: { ignoreRoute: true }
    }
  },
  {
    path: '/seller/menu/items/:id',
    name: 'MenuItemView',
    components: { default: MenuItemView, navigation: NavigationBar },
    props: { default: true, navigation: { back: true, backTo: -1 } },
    meta: {
      requiresAuth: true,
      transitionName: 'slide-up',
      sitemap: { ignoreRoute: true }
    }
  },
  {
    path: '/',
    name: 'UpcomingOrdersView',
    components: {
      default: UpcomingOrdersView,
      navigation: NavigationBar
    },
    meta: {
      requiresAuth: true,
      transitionName: 'slide-up',
      sitemap: { ignoreRoute: true }
    }
  },
  {
    path: '/seller/schedule',
    name: 'ScheduleView',
    components: {
      default: ScheduleView,
      navigation: NavigationBar
    },
    meta: {
      requiresAuth: true,
      transitionName: 'slide-up',
      sitemap: { ignoreRoute: true }
    }
  },
  {
    path: '/seller/payouts',
    name: 'PayoutsView',
    components: {
      default: PayoutsView,
      navigation: NavigationBar
    },
    meta: {
      requiresAuth: true,
      transitionName: 'slide-up',
      sitemap: { ignoreRoute: true }
    }
  },
  {
    path: '/seller/payouts/details',
    name: 'PayoutsAddDetailsView',
    components: {
      default: PayoutsAddDetailsView,
      navigation: NavigationBar
    },
    props: { default: false, navigation: { back: true } },
    meta: {
      requiresAuth: true,
      transitionName: 'slide-up',
      sitemap: { ignoreRoute: true }
    }
  }
]

export default sellerRoutes
